import React from 'react';
import Modal from './Modal';

interface ModalWrapperProps {
    isVisible: boolean;
    onBackdropClick: () => void;
    content: JSX.Element;
    type: String
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({ isVisible, onBackdropClick, content, type }) => {
    const body = document.querySelector("body");

    if (!body) return null;

    if (!isVisible) {
        body.style.overflow = "auto";
        return null;
    }
    else {
        body.style.overflow = "hidden";
    }

    return (
        <div className="">
            <Modal onBackdropClick={onBackdropClick} type={type}>
                {content}
            </Modal>
        </div>
    );
}

export default ModalWrapper